import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import Autosuggest from 'react-autosuggest';
import {mapquestRequest} from 'api/request';

function renderSuggestion(suggestion, {query}) {
  if (suggestion.isEmpty) {
    return null;
  }

  let item = <span>{suggestion.displayString}</span>;
  const idx = suggestion.displayString
    .toLowerCase()
    .indexOf(query.toLowerCase());

  if (idx === 0) {
    item = (
      <span>
        <b>{suggestion.displayString.substring(0, query.length - 1)}</b>
        {suggestion.displayString.substring(query.length - 1)}
      </span>
    );
  }

  return (
    <span className="">
      <i className="fa fa-map-marker" /> {item}
    </span>
  );
}

const renderInputComponent = ({semantic, ...inputProps}) =>
  semantic ? (
    <div className="ui left icon input">
      <input {...inputProps} style={{height: 38, width: 300}} />
      <i aria-hidden="true" className="icon search" />
    </div>
  ) : (
    <div className="inputContainer input-icon MHD-search-box">
      <input {...inputProps} />
      <i className="fa fa-search" />
    </div>
  );

const AddressSelect = props => {
  const [location, setLocation] = useState(null);
  const [suggestions, setSuggestions] = useState([]);

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        if (
          position &&
          position.coords &&
          position.coords.latitude &&
          position.coords.longitude
        ) {
          setLocation(position.coords);
        }
      });
    }
  }, []);

  const getSuggestionValue = suggestion => {
    props.onAddressSelected(suggestion.place.properties);

    return suggestion.place.properties.street;
  };

  const handleGetSuggestions = async ({value}) => {
    if (value.length < 2) {
      return; // mapquest requires at least 2 characters
    }

    try {
      const results = await mapquestRequest(value, location);

      if (results) {
        setSuggestions(results);
      } else {
        setSuggestions([]);
      }
    } catch (e) {
      setSuggestions([]);
    }
  };

  const inputProps = {
    className: 'form-control',
    onChange: (event, {newValue}) => props.onAddressChanged(newValue),
    placeholder: props.placeholder,
    semantic: props.semantic,
    value: props.address || '',
  };

  return (
    <Autosuggest
      getSuggestionValue={getSuggestionValue}
      inputProps={inputProps}
      onSuggestionsClearRequested={() => setSuggestions([])}
      onSuggestionsFetchRequested={handleGetSuggestions}
      renderInputComponent={renderInputComponent}
      renderSuggestion={renderSuggestion}
      suggestions={suggestions}
      theme={{
        container: `react-autosuggest__container${
          props.semantic ? ' semantic' : ''
        }`,
        containerOpen: 'react-autosuggest__container--open',
        input: 'react-autosuggest__input',
        inputOpen: 'react-autosuggest__input--open',
        inputFocused: 'react-autosuggest__input--focused',
        suggestionsContainer: 'react-autosuggest__suggestions-container',
        suggestionsContainerOpen:
          'react-autosuggest__suggestions-container--open',
        suggestionsList: 'react-autosuggest__suggestions-list',
        suggestion: 'react-autosuggest__suggestion',
        suggestionFirst: 'react-autosuggest__suggestion--first',
        suggestionHighlighted: 'react-autosuggest__suggestion--highlighted',
        sectionContainer: 'react-autosuggest__section-container',
        sectionContainerFirst: 'react-autosuggest__section-container--first',
        sectionTitle: 'react-autosuggest__section-title',
      }}
    />
  );
};

AddressSelect.defaultProps = {
  address: '',
  placeholder: '',
  semantic: false,
};

AddressSelect.propTypes = {
  address: PropTypes.string,
  placeholder: PropTypes.string,
  semantic: PropTypes.bool,

  // functions
  onAddressChanged: PropTypes.func.isRequired,
  onAddressSelected: PropTypes.func.isRequired,
};

export default AddressSelect;



// WEBPACK FOOTER //
// ./src/components/Common/Form/AddressSelect.js